module.exports = __webpack_public_path__ + "static/assets/facc24569f5d81d5cfbde856f0afc55f.png";